import { CartUpdateEvent } from '@theme/events';

const PFAND_VARIANT_ID = 58750663754073;
const TRAY_BOTTLES = 8;
const STEP = 1;

class CartQuantityConfigurator extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.rows = [...this.querySelectorAll('[data-variant-id]')];
    this.rows.forEach((row) => {
      const input = row.querySelector('input[type="number"]');
      input.addEventListener('input', () => this.renderRow(row));
      row.querySelectorAll('[data-step]').forEach((button) => button.addEventListener('click', () => {
        input.value = String(Math.min(Number(input.max), Math.max(0, Number(input.value) + Number(button.dataset.step))));
        this.renderRow(row);
      }));
      const resetButton = document.createElement('button');
      resetButton.type = 'button';
      resetButton.className = 'button button-unstyled quantity-configurator__reset';
      resetButton.textContent = '0';
      resetButton.setAttribute('aria-label', 'Menge auf 0 setzen');
      resetButton.addEventListener('click', () => {
        input.value = '0';
        this.renderRow(row);
      });
      row.querySelector('.quantity-configurator__product-main')?.append(resetButton);
    });
    this.querySelector('.configurator-close').addEventListener('click', () => this.close());
    this.querySelector('[data-update]').addEventListener('click', () => this.save());
    document.querySelectorAll('[data-open-cart-quantity-configurator]').forEach((button) => {
      button.addEventListener('click', () => this.open());
    });
  }

  async open(focusVariantId) {
    const cart = await (await fetch('/cart.js')).json();
    this.hidden = false;
    this.rows.forEach((row) => {
      const line = cart.items.find((item) => String(item.variant_id) === row.dataset.variantId);
      const input = row.querySelector('input');
      input.value = String(Math.min(Number(input.max), line?.quantity || 0));
      this.renderRow(row);
      row.toggleAttribute('data-focused', String(focusVariantId) === row.dataset.variantId);
    });
    this.dialog.showModal();
    this.querySelector('[data-focused]')?.scrollIntoView({ block: 'nearest' });
  }

  close() { this.dialog.close(); this.hidden = true; }

  renderRow(row) {
    const input = row.querySelector('input');
    const quantity = Math.min(Number(input.max), Math.max(0, Number(input.value) || 0));
    input.value = String(quantity);
    row.dataset.quantity = String(quantity);
    row.querySelector('[data-label]').textContent = `${quantity} Trays (${quantity * TRAY_BOTTLES} Flaschen)`;
    const totalTrays = this.rows.reduce((sum, item) => sum + Number(item.querySelector('input').value), 0);
    this.querySelector('[data-total]').textContent = `Gesamt: ${totalTrays} Trays (${totalTrays * TRAY_BOTTLES} Flaschen)`;
    const remaining = totalTrays === 0 ? 6 : (6 - (totalTrays % 6)) % 6;
    this.querySelector('[data-next-batch]').textContent = remaining === 0
      ? 'Vielfaches von 6 Trays erreicht'
      : `${remaining} Trays bis zum nächsten Vielfachen von 6`;
  }

  async save() {
    const button = this.querySelector('[data-update]');
    const totalTrays = this.rows.reduce((sum, row) => sum + Number(row.querySelector('input').value), 0);
    const validation = this.querySelector('[data-validation]');
    if (totalTrays !== 0 && (totalTrays < 6 || totalTrays % 6 !== 0)) {
      validation.textContent = 'Bitte wähle insgesamt mindestens 6 Trays und ein Vielfaches von 6 Trays.';
      validation.hidden = false;
      return;
    }
    validation.hidden = true;
    button.disabled = true;
    try {
      const cart = await (await fetch('/cart.js')).json();
      const desired = new Map(this.rows.map((row) => [row.dataset.variantId, Number(row.querySelector('input').value)]));
      const updates = {};
      cart.items.forEach((item) => { if (Number(item.variant_id) !== PFAND_VARIANT_ID && desired.has(String(item.variant_id))) updates[item.key] = desired.get(String(item.variant_id)); });
      const update = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      let updatedCart = await update.json();
      const additions = this.rows.filter((row) => Number(row.querySelector('input').value) > 0 && !cart.items.some((item) => String(item.variant_id) === row.dataset.variantId));
      if (additions.length) {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: additions.map((row) => ({ id: Number(row.dataset.variantId), quantity: Number(row.querySelector('input').value) })) }) });
        updatedCart = await response.json();
      }
      document.dispatchEvent(new CartUpdateEvent(updatedCart, 'cart-quantity-configurator', { source: 'cart-quantity-configurator', itemCount: updatedCart.item_count }));
      this.close();
    } finally { button.disabled = false; }
  }
}

if (!customElements.get('cart-quantity-configurator')) customElements.define('cart-quantity-configurator', CartQuantityConfigurator);
